import * as React from "react";
import './PromoContainer.css';
import {Context} from '../../state/Store';
import * as _ from 'lodash';
import {Trans, useTranslation} from "react-i18next";

const PromoContainer = () => {
  const {t} = useTranslation();
  const [state] = React.useContext(Context);
  const promoTypes = ['Standard', 'STARTUP', 'Educator', 'Developer', 'Student']
  
  const amount = state.defaultPromo.programType === 'STARTUP' && state.countryInfo !== undefined && state.countryInfo.promos !== undefined ? state.countryInfo.promos.STARTUP : '500';
  const promo = state.countryInfo !== undefined && state.countryInfo.promos !== undefined ? state.countryInfo.promos.Standard : '300';
  const currency = state.countryInfo !== undefined && state.countryInfo.currency !== undefined ? state.countryInfo.currency.symbol : '$';
  const promoAmount = _.indexOf(promoTypes, state.selectedPromo.type) === -1 || _.isEmpty(state.countryInfo) ? state.selectedPromo.promoAmount : state.countryInfo.promos[state.selectedPromo.type];
  
  const amtOrPromo = state.defaultPromo.programType === 'STARTUP' ? amount : promo;
  const displayName =  _.isEmpty(state.selectedPromo.campaignDisplayName) ? state.selectedPromo.type: state.selectedPromo.campaignDisplayName;
  const promoDays = state.selectedPromo.promoDurationInDays;
  
  return (
    <>
    {!state.nextStep && 
    <>
    {!_.isEmpty(state.selectedPromo) ?
      <div className="promoContainer">
        <h2>{t('promo.specialOfferTitle')}</h2>
        <p>{t('promo.welcome')} <strong>{state.username}</strong></p>
        <p>
        <Trans i18nKey="promo.selectedPromo">You have selected to sign up for: <strong>Oracle Cloud For {{displayName}} with {currency}{promoAmount} credits for {promoDays} days</strong></Trans>
        </p>
      </div>
    :
    <>
    {state.defaultPromo.programType === 'STARTUP' ? 
      <div className="promoContainer">
        <h2>{t('promo.promoStartupTitle', 'Startups get')}...</h2>
        <strong><Trans i18nKey='promo.promoStartupDesc'>{currency}{amtOrPromo} credits for Oracle Cloud, plus gain access to additional credits and other exclusive benefits</Trans>.</strong>
        <br /> <br />
        <div><Trans i18nKey="promo.promoStartupDesc1">Not a startup? <a href= {window.location.pathname}>Click here</a></Trans></div>

      </div> 
      :
      <div className="promoContainer">
        <h2>{t('promo.promo1Title')}</h2>
        
          <strong>{t('promo.promoApplicationTitle')}</strong>
          <ul>
            <li>{t('promo.promoApplication1')}</li>
            <li>{t('promo.promoApplication2')}</li>
            <li>{t('promo.promoApplication3')}</li> 
          </ul> 
        
          <strong><Trans i18nKey="promo.promoServiceTitle1">Plus, {currency}{amtOrPromo} of credits for 30 days to use on even more services:</Trans></strong>
          <ul>
            <li>{t('promo.promoService1')}</li>
            <li>{t('promo.promoService2')}</li>
            <li>{t('promo.promoService3')}</li> 
          </ul> 
      </div>}
      </>
    }
    </>}
    </>
  )
}

export default PromoContainer;
